import React, { Component } from 'react'
import { withCookies, Cookies } from 'react-cookie'
import { ChatProvider, Channel } from '@aicon-dev/caas-chat'
import Axios from 'axios'
import Auth from '../../Modules/Auth'
import PDFReader from '../../Components/Commons/PDFReader'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import './ChatPage.scss'

const msOfficeTypes = ['.ppt', '.pptx', '.xlsx', '.xls', '.doc', '.docx']

class ChatPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            user: {
                _id: '',
            },
            channelUrl: '',
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    loadUser = () => {
        Axios.get(`${BACKEND_HOST}/auth/me`, {
            headers: {
                Authorization: `bearer ${Auth.getToken()}`,
            },
        })
            .then((res) => {
                this.setState({ user: res.data })
                this.loadChatSetting()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadChatSetting = () => {
        const { cookies } = this.props
        Axios.get(`${PROXY_HOST}/api/solutionSetting?project_id=${cookies.get('project')}`, {
            headers: {
                Authorization: `bearer ${Auth.getToken()}`,
            },
        })
            .then((res) => {
                if (res.data.chatOpen) {
                    this.setState({
                        channelUrl: cookies.get('project_chatRoom'),
                    })
                } else {
                    // 쿠키에서도 disable 시키기
                    const expire = new Date()
                    expire.setDate(expire.getDate() + 365)
                    cookies.set('project_chatOpen', res.data.chatOpen, {
                        path: '/',
                        maxAge: 31536000,
                        expires: expire,
                    })
                    // 세팅이 접속 불가 상태이면 대시보드로 이동
                    this.props.history.push(`/`)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { cookies } = this.props

        return (
            <div>
                <HeaderMenu />

                <div className="section_wrap section_wrap_menu">
                    <div className="chat_wrap">
                        <div className="section">
                            {!!this.state.channelUrl && (
                                <ChatProvider
                                    renderFilePreview={(file) => {
                                        if (file.filename.toLowerCase().includes('pdf')) {
                                            return <PDFReader url={file.url} />
                                        } else if (msOfficeTypes.some((type) => file.filename.includes(type))) {
                                            return (
                                                <iframe
                                                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${file.url}`}
                                                    style={{ height: '400px', width: '100%' }}
                                                />
                                            )
                                        } else {
                                            ;<></>
                                        }
                                    }}
                                    channelUrl={this.state.channelUrl}
                                    extentions={['attachment']}
                                    shareDocument={{
                                        checkJoinedProject: (projectId) => {
                                            if (cookies.get('project') === projectId) {
                                                return true
                                            } else {
                                                return false
                                            }
                                        },
                                        onClickReport: (data) => {
                                            const projectId = cookies.get('project')
                                            if (projectId === data.project_id) {
                                                const docId = data._id
                                                const url = `/report/${docId}`
                                                this.props.history.push(url)
                                            }
                                        },
                                        onClickRfi: (data) => {
                                            const projectId = cookies.get('project')
                                            if (projectId === data.project_id) {
                                                if (data.writer_id === this.state.user._id) {
                                                    const docId = data._id
                                                    const url = `/demand/${docId}`
                                                    this.props.history.push(url)
                                                } else if (data.assignee_id === this.state.user._id) {
                                                    const docId = data._id
                                                    const url = `/todo/${docId}`
                                                    this.props.history.push(url)
                                                }
                                            }
                                        },
                                        onClickMinutes: (data) => {
                                            const projectId = cookies.get('project')
                                            if (projectId === data.project_id) {
                                                const docId = data._id
                                                const url = `/meeting/${docId}`
                                                this.props.history.push(url)
                                            }
                                        },
                                    }}>
                                    <Channel
                                        showHeader={false}
                                        onClose={() => this.props.history.push('/')}
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                        }}
                                    />
                                </ChatProvider>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(ChatPage)



// WEBPACK FOOTER //
// ./Src/Containers/Chat/ChatPage.js